module.exports = __webpack_public_path__ + "img/a1614dd.png";